export const EducationData = [
  {
    id: 1,
    title: " درد سے بچیں ",
    description: " اس موقع پر آپ کو محدود سا درد ہونا چاہیے۔ اگر آپ کو اب بھی بہت زیادہ درد ہو تو فوری طور پر اپنے صحت کی سہولت فراہم کرنے والےسے رجوع کریں۔ ",
  },
  {
    id: 2,
    title: " سوجن سے بچیں ",
    description: " آپ کو اس وقت سوجن نہیں ہونی چاہیے یا بہت معمولی ہونی چاہیے۔ اگر آپ کو اب بھی بہت زیادہ درد ہو تو فوری طور پر اپنے صحت کی سہولت فراہم کرنے والےسے رجوع کریں۔ ",
  },
  {
    id: 3,
    title: " توازن کی ہدایات ",
    description: " گھٹنے کی تبدیلی کے بعد توازن کی مشق ضروری ہے۔ آپ کونسی ورزشیں کر سکتے ہیں، اس کا دارومدار اس بات پر ہے کہ آپ سرجری سے پہلے کیا کر سکتے تھے۔ ہر ایک ورزش صرف اس صورت میں کریں جب آپ کو گرنے یا چوٹ لگنے کا کوئی خطرہ نہ ہو۔ یہ یقینی بنانے کے لیے کہ آیا آپ ان ورزشوں کو مکمل کرنے کے لیے محفوظ ہیں اپنے معالج سے مشورہ کریں۔ ",
  },
  {
    id: 4,
    title: " کھنچاؤ کی معلومات ",
    description: " کھنچاؤ کے لیے ضروری ہے کہ آپ 10 سیکنڈ تک ایک حالت پر قائم رہیں اور درمیانے درجے کے کھنچاؤ کا احساس برقرار رکھیں۔ اگر کھنچاؤ بہت زیادہ محسوس ہوتا ہے تو اس سے کوئی فائدہ نہیں ہوگا۔ اس کے علاوہ کھنچاؤ کی حالت کو بار بار تبدیل نہ کریں۔ ",
  },
  {
    id: 5,
    title: " تیز چلنا ",
    description: " ہفتے میں 4 بار 30 منٹ کے لئے مضبوط ہموار سطح پر تیز چلیں۔ ",
  },
  {
    id: 6,
    title: " گھٹنے کی حرکت کی طاقت کو محفوظ رکھیں ",
    description: " اگر آپ کے معالج نے آپ کو ایسا کرنے کی ہدایت کی ہے یا اگر آپ کا گھٹنا مکمل حرکت کرنے نہیں لگا ہے تو، گھٹنے کو موڑنے اور سیدھا کرنے کی مشقیں جاری رکھیں۔ ورنہ ان کی ضرورت نہیں ہے۔ ",
  },
  {
    id: 7,
    title: "  ورزشی سائیکل تیس منٹ ",
    description: " سیٹ نیچے اور درمیانی سختی والی ورزشی سائیکل پورے چکر کے ساتھ ہفتے میں 3 بار ورزشی سائیکل کے ساتھ متبادل تیز واک ",
  },
]